const FILESTACK_BASE = "https://cdn.filestackcontent.com"
const HERO_SRCSET_WIDTHS = [640, 960, 1280, 1920]

/**
 * Extract Filestack handle from a URL (with or without existing transform).
 * e.g. "https://cdn.filestackcontent.com/resize=width:1920,fit:max/ABC123" -> "ABC123"
 */
export function getFilestackHandleFromUrl(url) {
  if (!url || typeof url !== "string" || !url.includes("cdn.filestackcontent.com")) return null
  const parts = url.split("/")
  const handle = parts[parts.length - 1]
  return handle || null
}

/**
 * Build srcset for hero images for responsive loading (smaller file sizes on small viewports).
 * Returns null if URL is not a Filestack URL.
 */
export function getHeroImageSrcSet(url) {
  const handle = getFilestackHandleFromUrl(url)
  if (!handle) return null
  // fit:max scales without re-cropping so framing matches builder preview (CSS object-cover).
  return HERO_SRCSET_WIDTHS.map((w) => `${FILESTACK_BASE}/resize=width:${w},fit:max/${handle} ${w}w`).join(", ")
}
